// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__uqXA3","title":"ClientCherryInfo_title__3xI9Q","itemText":"ClientCherryInfo_itemText__5Qr2T"};